module.exports = __webpack_public_path__ + "static/media/money.65ba4aaf.svg";